
  
  <template>
  <v-content class="ma-0 pa-0">
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title>Fracciones activas</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        v-if="oidcUser==null"
        href="https://intranet3.ugto.mx/Transparencia/"
        onclick="javascript:openWindow(this.href);return false;"
        light
      >Inicia sesion</v-btn>
    </v-toolbar>
    <v-tabs>
      <v-tab>
        <v-icon left>picture_in_picture</v-icon>Clasificador Fracciones
      </v-tab>
      <v-tab>
        <v-icon left>picture_in_picture</v-icon>Clasificador Unidades
      </v-tab>
      <v-tab>
        <v-icon left>list</v-icon>Tabla
      </v-tab>

      <v-tab-item>
        <v-flex xs12 sm3>
          <v-text-field filled label="Buscar" v-model="titlef"></v-text-field>
        </v-flex>
        <v-layout wrap>
          <v-flex xs12 sm4 lg4 text-sm-right v-for="(item, i) in searchFiltroF" :key="i">
            <material-stats-card
              :color="item.color"
              :icon="item.icono"
              :title="item.descripcionCorta"
              :titvalue="item.descripcionCorta"
              :sub-text="item.artist"
              :to="'CatArchivo/'+item.idUnidad"
            />
          </v-flex>
        </v-layout>
      </v-tab-item>

      <v-tab-item>
        <v-flex xs12 sm3>
          <v-text-field filled label="Buscar" v-model="title"></v-text-field>
        </v-flex>
        <v-layout wrap>
          <v-flex xs12 sm4 lg4 text-sm-right v-for="(item, i) in searchFiltro" :key="i">
            <material-stats-card
              :color="item.color"
              :icon="item.icono"
              :title="item.nombreUnidad"
              :titvalue="item.nombreUnidad"
              sub-icon="mdi-calendar"
              :sub-text="item.artist"
              :to="'CatArchivo/'+item.idUnidad"
            />
          </v-flex>
        </v-layout>
      </v-tab-item>

      <v-tab-item>
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="desserts"
            sort-by="calories"
            class="elevation-1"
            :search="search"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Fracciones</v-toolbar-title>
                <v-divider class="mx-3" inset vertical></v-divider>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>
            <template v-slot:item.action="{ item }">
              <!-- <v-icon small class="mr-2"   @click="dialog = true"> find_in_page</v-icon> -->
              <v-icon md class="mr-2" @click="modalitem(item)">find_in_page</v-icon>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="open">Datos no encontrados</v-btn>
            </template>
          </v-data-table>
        </v-card>
        <v-dialog
          v-model="dialog"
          max-width="1100"
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>ArchivosX</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>

            <v-divider></v-divider>
            <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
            <!-- <v-flex v-model="tablar"> -->
            <v-card>
              <v-data-table
                :headers="aheaders"
                :items="adesserts"
                sort-by="calories"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>Archivos</v-toolbar-title>
                    <v-divider class="mx-3" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>

                <template v-slot:item.action="{ item }">
                  <v-icon md class="mr-2" @click="desArchivo(item)">picture_as_pdf</v-icon>
                  <!-- <v-icon small class="mr-2"  @click="open"> find_in_page</v-icon> -->
                </template>
                <template v-slot:no-data>
                  <v-btn color="primary" @click="modalitem">Reset</v-btn>
                </template>
              </v-data-table>
            </v-card>
            <!-- //////////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
          </v-card>
        </v-dialog>
      </v-tab-item>
    </v-tabs>
    <v-divider></v-divider>
  </v-content>
</template>

<script>
import PubFracciones from "./PubFracciones.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import axunidad from "axios";
import { async } from "q";

//validacion del for,ulario

//termina validacionde formulario

// import Ptbls  from '@/components/PubFracciones.vue'

export default {
  components: { PubFracciones },

  props: [],

  data: () => ({
    backgroundColor: "primary",
    dialogm1: "",
    search: "",
    dialogm2: false,
    dialog3: false,
    step: 1,
    dialog: false,
    list: null,
    title: "",
    titlef: "",
    window: 1,
    name: "",
    email: "",
    icon: "",
    fitems: [],
    select: null,
    details: {
      colors: [] // icons: []
    },
    formClasi: {
      icon: ""
    },

    checkbox: false,
    headers: [
      { text: " # Fraccion", value: "numFraccion" },
      { text: "Fraccion", value: "fraccion" },
      { text: "tipo fraccion", value: "tipoFraccion" },
      { text: "Archivos", value: "action", sortable: false }
    ],

    aheaders: [
      { text: "Archivo ", value: "nombreArchivo" },
      { text: "año", value: "anio" },
      { text: "periodo", value: "periodo" },
      { text: "Actualizacion", value: "fechaCreacion" },
      { text: "descargar", value: "action", sortable: false }
    ],
    desserts: [],
    adesserts: [],
    editedIndex: -1,
    editedItem: {
      nombreUnidad: "",
      Siglas: 0,
      idUnidad: 0
    },
    defaultItem: {
      nombreUnidad: "",
      Siglas: 0,
      idUnidad: 0,
      idFraccion: 0
    },
    respddl: [],
    items: [],
    aitems: [],
    arid: 0

    // fitems: [
    // {
    //   color: '#FF7272',
    //   src: 'mdi-book-search-outline',
    //   title: 'Dirección de Recursos Financieros',
    //    link: '10'
    // },
    // ],
  }),

  computed: {
    styleHeader() {
      return {
        backgroundColor: this.formClasi.color,
        color: this.formClasi.forecolor
      };
    },

    ...mapGetters({
      oidcUser: "oidcStore/oidcUser",
      oidcAccessToken: "oidcStore/oidcAccessToken"
    }),

    slotData() {
      return {
        details: this.details
      };
    },

    isReadOnly() {
      return this.readOnly || this.$dayspan.readOnly;
    },

    searchFiltro: function() {
      return this.fitems.filter(item => item.nombreUnidad.includes(this.title));
    },
    searchFiltroF: function() {
      return this.desserts.filter(item =>
        item.numFraccion.includes(this.title)
      );
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  created() {
    let self = this;
    //  this.initialize();
    self.getCatUnidad();
  },

  methods: {
    ...mapActions({
      signOutOidc: "oidc/signOutOidc"
    }),

    getCatUnidad() {
      let self = this;
      self.$store.state.services.fraccionService.getCatUnidad().then(r => {
        this.fitems = r.data.data;
        console.log(this.fitems);
      });
      self.tblFraccion();
    },
    tblFraccion() {
      let self = this;
      self.$store.state.services.fraccionService.getCatFraccion().then(r => {
        this.desserts = r.data;
        console.log("desserts", this.desserts);
      });
    },
    modalitem(item) {
      let self = this;
      const index = this.desserts.indexOf(item);
      console.log("modal", item);
      self.$store.state.services.fraccionService

        .tblArchivos(item.idFraccion)
        .then(r => {
          this.adesserts = r.data;
          console.log("adeserts", this.adesserts);
        });

      console.log(this.editedItem);
      this.dialog = true;
    },

    desArchivo(item) {
      let self = this;
      const index = this.desserts.indexOf(item);
      console.log("Archico", item);
      self.$store.state.services.fraccionService

        .archivodow(item.idArchvio)
        .then(r => {
          this.adesserts = r.data;
          //console.log( "adeserts",this.adesserts);
        });

      console.log(this.editedItem);
      this.dialog = true;
    },

    di: function(mensaje) {
      return (this.icon = mensaje);
    },

    submit() {
      this.$v.$touch();
    },
    btnicon() {
      console.log(this.key);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    }
  }
};
</script>

<style scoped lang="scss">
.v-btn--floating.v-btn--left {
  margin-left: 0px !important;

  .v-icon {
    height: auto;
  }
}

.ds-calendar-event-popover-card {
  .v-toolbar__extension {
    padding: 0 16px !important;
    height: 60px !important;
    align-items: start;

    .v-toolbar__title {
      width: 100%;
      margin-left: 56px;
      margin-right: 0px;

      .v-input__slot {
        background-color: rgba(255, 255, 255, 0.2) !important;

        input {
          caret-color: rgba(0, 0, 0, 0.87) !important;
        }
      }
    }
  }
}

.v-text-field--full-width {
  width: 100%;
}

.v-card__text {
  padding: 16px 0;

  .v-list {
    padding-bottom: 0px;

    > div:first-child {
      margin-bottom: 1em;
    }

    .v-list__tile {
      height: auto !important;
    }
  }
}

.ds-create-popover-save {
  background-color: transparent !important;
}

.ds-color-option {
  width: 100%;
  color: white;
  padding: 4px;
}

.v-input {
  margin-bottom: 8px !important;
}
</style>

